import React, { useState } from 'react';
import { FormGroup } from 'reactstrap';
import { Field } from 'react-final-form';
import classnames from 'classnames';

import { Intl } from 'components';

export default ( {
  field, validate, showIcon = undefined, Element,
} ) => (
  <Field name={field} validate={validate}>
    {( { meta, input } ) => {
      const isInvalid = meta.touched && meta.error;
      const [cardError, setCardError] = useState( null );

      return (
        <FormGroup className={classnames( 'stripe-card-element', { 'is-invalid': isInvalid } )}>
          <Element
            options={{
              showIcon,
              classes: {
                base: 'form-control form-control-xsm',
                invalid: 'is-invalid',
              },
            }}
            onChange={( el ) => {
              if ( !el ) return input.onChange( null );

              if ( el && el.error && el.error.message ) {
                setCardError( el.error.message );
                input.onChange( null );
              } else if ( el.empty ) {
                setCardError( null );
                input.onChange( null );
              } else {
                setCardError( null );
                input.onChange( 'true' );
              }
            }}
          />
          {( cardError || isInvalid )
          && (
            <div className="invalid-feedback">
              {cardError || <Intl id={meta.error} />}
            </div>
          )}
        </FormGroup>
      );
    }}
  </Field>
);
